<template>
  <div>
    <div class="block__container block__container--compact">
      <step-header-component :headerText="headerText" :subHeaderText="subHeaderText"></step-header-component>
      <progress-bar
        :hideForwardNavigation="hideForwardNavigation"
        :hideBackwardNavigation="hideBackwardNavigation"
        :validationScope="validationScope"
        :progressBarValue=70>
      </progress-bar>
      <address-lookup :validationScope="validationScope"></address-lookup>
      <vehicle-card :showVehicleInfo="true" :showVehicleImage="true"></vehicle-card>
      <next-button :validationScope="validationScope" :buttonText="buttonText"></next-button>
    </div>
    <div class="block--center">
      <pricing-data></pricing-data>
    </div>
    <div class="block__container">
      <start-again></start-again>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import StepHeaderComponent from '../general/StepHeaderComponent.vue';
import ProgressBarComponent from '../general/ProgressBarComponent.vue';
import NextButtonComponent from '../navigation/NextButtonComponent.vue';
import PricingDataComponent from '../pricing/PricingDataComponent.vue';
import StartAgainComponent from '../navigation/StartAgainComponent.vue';
import AddressLookupComponent from '../enquiry/AddressLookupComponent.vue';
import VehicleCardComponent from '../vehicle/VehicleCardComponent.vue';

@Component({
  components: {
  'step-header-component': StepHeaderComponent,
  'progress-bar': ProgressBarComponent,
  'address-lookup': AddressLookupComponent,
  'vehicle-card': VehicleCardComponent,
  'next-button': NextButtonComponent,
  'pricing-data': PricingDataComponent,
  'start-again': StartAgainComponent
  }
  })

export default class AddressStepComponent extends Vue {
  @Prop({ default: 'Here\'s your vehicleType' })
  public headerText!: string;

  @Prop({ default: 'Confirm your postcode so we can find you local deals' })
  public subHeaderText!: string;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: false })
  public hideForwardNavigation!: boolean;

  @Prop({ default: false })
  public hideBackwardNavigation!: boolean;

  private buttonText: string = 'This is the vehicleType for me';
}
</script>
